import React, { Component } from 'react';
import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { history } from '../history';
//import {comm} from '../comm';
import { integration } from '../integration';
import {Bkg} from '../elements/Elements';
import {Button} from '../elements/Buttons';
import { i18n } from '../i18n';
import {B64Image} from './B64Image';
//import {TutorialServer} from '../server/TutorialServer';
import {motion} from 'framer-motion';
import {Gleam} from '../webview/Gleam';
import {SpreadedContent} from '../elements/ModalElements';

@observer
export class Lobby extends Component {
	constructor(props) {
		super(props);

		//store.preventReturnToSplash = true;
		store.topBar.to = '';
		store.topBar.back = false;
		store.topBar.showHeart = false;
		store.showBottomNav = false;
		store.pokerRush = false;
		store.botVideo = false;
		store.skillzTimeTicking = false;
		store.skillzHearts = 0;

		const count = ~~localStorage.getItem('bootCount');
		if(!store.settings.notifications
			// && ((store.isAndroid && ~~(store.osVersion.split(' ')[2]) >= 13) || store.isDev)
			&& count > 1 && count % 5 === 0
		) {
			store.modal = 'turnOnNotifications';
		}
	}
	componentDidMount() {
		if(!store.isSkillzInited && !store.user.hasSeenTutorial && localStorage.getItem('skippedTutorial') === 'yes') {
			integration.postAnalyticsEvent_v3('lobby_shown', 'user_experience');
		}
		if(!store.onBackButton)
			store.onBackButton = this.showExitModal;
		store.pokerRush = false;
		store.botVideo = false;
	}

	showExitModal = () => {
		store.modal = 'exitApp';
	};

	startMatch() {
		//window.manager.playAudio("poopPop");
		/* if(store.isDev) {	// to dev check Skillz Error popup 
			store.skillzResponse = {errorCode: 'A001, A002', sessionId: '123456789123456789'}
			store.showSkillzError = true;
		} */
		store.isSkillzInited = false; 	// as we don't need to wait for Skillz UI initialization
		store.createMatch(1).then(response => {
			history.push(`/game/${response.Match.Id}/play`);
		})
		//store.isSkillzInited = !store.isDev; //true;
		window.WrapperApp.postMessage('init-skillz');
	}

	clickSkip = () => {
		window.manager.ui.skipTutorial();
	}

	onRollButton = () => {
		if(this.props.tutorial) {
			console.log('7616 LOBBY FROM tutorial');
			// finish tutorial
			window.setPersistentStorage('skippedTutorial', 'yes');
			integration.onTutorialCompleted();
			store.tutorialMode = false;
			this.startMatch();
		} else if (this.props.main) {
			console.log('7616 LOBBY go to skillz match from here')
			this.startMatch();
		}
	}

	render() {
		return store.isSkillzInited ? null :
		/* (!store.user.hasSeenTutorial && localStorage.getItem('skippedTutorial') === 'yes') ? */
		<LogoAnimationScreen onClick={this.startMatch}/>
		/* :
		<AvaAnimationScreen tutorial={this.props.tutorial} 
			onRoll={this.onRollButton}
			//onRoll={this.startMatch}
			onSkip={this.clickSkip}
		/> */

	}
}
/* const AvaAnimationScreen = p => { 
	const moveTime = 0.25;
	return <div className={p.className}>
		<Rules h={65} w={70}t={20}
			initial={{x: '100vw'}} animate={{x: '0vw'}}
			transition= {{duration: moveTime, delay: 0.5*moveTime}}
		>
			<Bkg src="/assets/popups/panel_blue_small.png"/>
			<SpreadedContent h={50}>
				<Title>{i18n.t('hi_ava')}</Title>
				<Text>{i18n.t('ready_free')}</Text>
			</SpreadedContent>
		</Rules>
		<AvaCircle src="/assets/popups/ava_circular.png" t={65}
			initial={{x: '-50vw'}} animate={{x: '0vw'}}
			transition= {{duration: moveTime}}
		/>
	
		<RollBtn t={108}
			initial={{opacity: 0}} animate={{ opacity: 1}}
			transition={{duration: moveTime, delay: 2*moveTime}}
		>
			<motion.div
				initial={{scale: 1 }}
				animate={{scale: 1.1}}
				transition={{delay: 3*moveTime, duration: 1, yoyo: Infinity}}
			>
				<Button w='50vw' h='6vw' onClick={p.onRoll} 
					fontSize={{en: '5.5vw'}}
				>
					{i18n.t(p.tutorial ? 'lets-roll' : 'play_now')}
				</Button>
			</motion.div>
		</RollBtn>
	</div>
}; */

const Rules= styled(motion.div)`
	width: ${p => p.w}vw;	
	height: ${p => p.h}vw;
	position: absolute;
	top: ${p => p.t}vw; 
	left: ${p => 50 - p.w/2}vw;
	color: #156082;
    text-shadow: none;
`;
const Title = styled.div`
	font-size: 8vw;
	font-weight: 900;
	position: relative;
	text-align: center;
    text-transform: uppercase;
	margin: 5vw auto 3vw;
`;
/* const Text = styled.div`
	font-weight: 800;
	font-size: 6vw;
	width: 75%;
	text-align: center;
`; */
const Rule = styled(motion.div)`
	font-size: 5vw;
	width: 80%;
`;
const AvaCircle = styled(motion.img)`
	position: absolute;
	left: 0vw;
	top: ${p => p.t}vw;
	width: 40vw;
`;
const RollBtn = styled(motion.div)`
	position: absolute;
	top: ${p => p.t}vw;
	left: 25vw;
`;

export const AvaSplashScreen = styled(p => {
	const moveTime = 0.25;
	return <div className={p.className}>
		<Rules h={95} w={80} t={-30}
			initial={{x: '100vw'}} animate={{x: '0vw'}}
			transition= {{duration: moveTime, delay: 0.5*moveTime}}
		>
			<Bkg src="/assets/popups/panel_blue_small.png"/>
			<Title>{i18n.t('how_to_play')}</Title>
			<SpreadedContent h={57}>
				{[1,2,3,4,5].map(i => <Rule key={'rt_'+i}
					initial={{opacity: 0}} 
					animate={{opacity: 1}}
					transition={{
						duration: moveTime, 
						delay: (i*0.5 + 1.5)* moveTime
					}}
				>
					{i18n.t('how_to_play_'+i)}	
				</Rule>)}
			</SpreadedContent>
		</Rules>
		<AvaCircle src="/assets/popups/ava_circular.png"t={47}
			initial={{x: '-50vw'}} animate={{x: '0vw'}}
			transition= {{duration: moveTime}}
		/>
	
		<RollBtn t={88}
			initial={{opacity: 0}} animate={{ opacity: 1}}
			transition={{duration: moveTime, delay: 5*moveTime}}
		>
			<motion.div
				initial={{scale: 1 }}
				animate={{scale: 1.1}}
				transition={{delay: 6*moveTime, duration: 1, yoyo: Infinity}}
			>
				<Button w='50vw' h='6vw' onClick={p.onClick} 
					fontSize={{en: '5.5vw'}}
				>
					{i18n.t('lets-roll')}
				</Button>
			</motion.div>
		</RollBtn>
	</div>
})`
	position: relative;
    width: 100vw;
    height: 100vh;
    margin: -20vh;

	@media (min-aspect-ratio: 3/4) {
		transform: scale(0.8) !important;
		margin-top: -25vh;
	}
`;

const LogoAnimationScreen = styled(p => { 
	const tick = 1/30;
	const promo = Gleam.availableInLobby && Gleam.getActivePromo();
	return <div className={p.className}>
		<AnimBox>
			<LogoImg	src='/assets/skillz/roll_1_bottom.png'
				initial={{ y: '-50vh' }}
				animate={{ y: ['-50vh', '15vh', '6vh']}}
				transition={{duration: 10*tick, times:[0, 0.5, 1] }}
				onAnimationStart={() => window.manager.playAudio('Transitions_Movement')}
			/>
			<CupDiv
				initial={{ x: '-50vw' }}
				animate={{ x: ['-50vw', '10vw', '3.5vw']}}
				transition={{delay: 7*tick, duration: 10*tick, times:[0, 0.5, 1] }}
				onAnimationStart={() => window.manager.playAudio('diceRoll')}
			>
				<CupImg		src='/assets/skillz/cup_bottom.png'/>
				<DiceImg		src='/assets/skillz/jack.png' initial={{ scale: 0}} 		
					animate={{ x: '49.85vw', y: '2vw', scale: 1}}
					transition={{delay: 13*tick, duration: 5*tick, scale:{duration: 0.1}}}
				/>
				<DiceImg		src='/assets/skillz/queen.png' initial={{ scale: 0}} 
					animate={{ x: '37.5vw', y: '4.8vw', scale: 1}}
					transition={{delay: 14*tick, duration: 4*tick, scale:{duration: 0.1}}}
				/>
				<DiceImg		src='/assets/skillz/ace.png' initial={{ scale: 0}} 
					animate={{ x: '17.7vw', y: '5.8vw', scale: 1}}
					transition={{delay: 16*tick, duration: 2*tick, scale:{duration: 0.1}}}
				/>
				<DiceImg		src='/assets/skillz/king.png' initial={{ scale: 0}} 
					animate={{ x: '27.7vw', y: '6vw', scale: 1}}
					transition={{delay: 15*tick, duration: 3*tick, scale:{duration: 0.1}}}
				/>
				<CupImg		src='/assets/skillz/cup_top.png'/>
			</CupDiv>
		</AnimBox>
		<motion.div
			initial={{ y: '50vh'}}
			animate={{ y: ['50vh', '-3vh', '0vh']}}
			transition={{delay: 22*tick, duration: 10*tick, times:[0, 0.5, 1]}}
		>
			<motion.div
				initial={{scale: 1 }}
				animate={{scale: 1.1}}
				transition={{delay: 30*tick, duration: 1, yoyo: Infinity}}
			>
				<Button w='50vw' h='5vh' onClick={p.onClick}
					fontSize={{en: 'min(3.5vh, 7vw)'}}
				>
					{i18n.t('play_now')}
				</Button>
			</motion.div>
		</motion.div>
		<PoweredBy alt="powered by dod" src={"/assets/splash/splash_poweredByDOD.png"} vis={'false'} />
		{!!promo && <GleamBanner bkg={promo.image} 
			onClick={() => Gleam.openUrl(promo.url)}
		/>}
		
	</div>
})`
	background: url('/assets/splash/bg_splash.jpg') center/cover black;
	display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 100%;
`
const AnimBox = styled.div`
	position: relative;
	flex: 0 1 50vh;
	margin-bottom: 10vh;
	width: 87vw;
`;
const CupDiv = styled(motion.div)`
	position: relative;
	top: calc(35vw + 6vh);
	img {position: absolute;}
`;
const LogoImg = styled(motion.img)` 
	position: absolute;
	top: 0; left: 0;
	width: 100%;
`
const CupImg = styled(motion.img)` width: 38vw; `
const DiceImg = styled(motion.img)` width: 20vw; top: 5vw; left: 11vw;`
const PoweredBy = styled(B64Image)`
	height: 18vh;
	margin: 5vh 0 5vw;
	opacity: ${p => p.vis === 'true' ? 1 : 0};
`;
const GleamBanner = styled.div`
	width: 100%;
	position: absolute;
	bottom: 0;
	height: calc(5vw + 18vh + 5vh);
	background: url(${p => p.bkg}) center bottom/contain no-repeat;
`;